/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { object, string, shape } from 'prop-types';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import Button from '@material-ui/core/Button';
import mbpLogger from 'mbp-logger';
import withStyles from '@material-ui/core/styles/withStyles';
import { GRAPHQL_ENV } from '../../../../../gql';
import PDPDeliveryPopup from './PDPDeliveryPopup';
import { setLocale } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { getDataDictionary } from '../../../../../../state/ducks/App/App-Selectors';

const styles = () => ({
    title: {
        textAlign: 'center',
        margin: 0,
        padding: 7,
    },
    popupButton: {
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
        fontSize: '12px',
        fontWeight: 'bold',
        width: '100%',
        padding: '10px',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    deliveryDetail: {
        display: 'flex',
    },
    deliveryDetailsIcon: {
        display: 'block',
    },
    titleCheckout: {
        textAlign: 'left',
        margin: 0,
        padding: 7,
    },
    popupButtonCheckout: {
        fontSize: '12px',
        fontWeight: 'bold',
        width: '100%',
        padding: '10px 0',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
});
const PDPDeliveryPopupContainer = ({
    brand, productDeliveryType, classes, pageType, dataDictionary,
}) => {
    const [openModal, closeModal] = useState(false);
    function toggle() {
        closeModal(!openModal);
    }
    const contentType = 'design_and_delivery_details';
    const DELIVERY_POPUP_QUERY = gql`{
        findContent(brand: "${brand.domain}", environment: "${GRAPHQL_ENV}", contentType: "${contentType}", query:"{\\"title\\" : \\"${productDeliveryType}\\"}", locale: "${setLocale()}")
        { content }
    }  
    `;
    const [getDeliveryPopupDetail, { data, loading, error }] = useLazyQuery(DELIVERY_POPUP_QUERY);
    if (loading) {
        return null;
    }
    if (error) {
        mbpLogger.logError({
            query: DELIVERY_POPUP_QUERY,
            jsError: error,
            component: 'PDPDeliveryPopupContainer.js',
            message: `Failed to fetch content data for: content type ${contentType} on brand ${brand}`,
            env: GRAPHQL_ENV,
        });
    }
    const popUpData = data?.findContent?.content?.entries || [];
    // flowers or berries or fruit bouquets
    return (
        <>
            <Button
                data-testid="pdp-delivery-details"
                className={pageType === 'checkout' ? classes.popupButtonCheckout : classes.popupButton}
                onClick={() => {
                    getDeliveryPopupDetail();
                    closeModal(!openModal);
                }}
            >
                {productDeliveryType === 'FPT'
                    ?                       (
                        <div className={classes.deliveryDetail}>
                            <img className={classes.deliveryDetailsIcon} src="https://images.contentstack.io/v3/assets/blt1253a5c1b168c76d/blt71ae1d59da4bf86e/6015f2ee0069f70f77721c48/group_1607.svg" alt="delivery details icon"  />
                            <p className={pageType === 'checkout' ? classes.titleCheckout : classes.title}>{dataDictionary?.['Designed & Delivered by a Local Shop: What to Expect'] || 'Designed & Delivered by a Local Shop: What to Expect'}</p>
                        </div>
                    )
                    : (
                        <div className={classes.deliveryDetail}>
                            <img className={classes.deliveryDetailsIcon} src="https://images.contentstack.io/v3/assets/blt1253a5c1b168c76d/bltf22263ece34caa07/6015f2ee3c38be10329e5844/group_1625.svg" alt="delivery details icon"  />
                            <p className={pageType === 'checkout' ? classes.titleCheckout : classes.title}>{dataDictionary?.['Your Carrier-Shipped Gift: What to Expect'] || 'Your Carrier-Shipped Gift: What to Expect'}</p>
                        </div>
                    )}
            </Button>
            <PDPDeliveryPopup popUpData={popUpData} closeModal={toggle} openModal={openModal} />
        </>
    );
};
PDPDeliveryPopupContainer.propTypes = {
    classes: object.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    pageType: string,
    productDeliveryType: string.isRequired,
    dataDictionary: object,
};

PDPDeliveryPopupContainer.defaultProps = {
    pageType: '',
    dataDictionary: {},
};

const mapStateToProps = (state) => ({
    dataDictionary: getDataDictionary(state),
});

export default connect(mapStateToProps)(withStyles(styles)(PDPDeliveryPopupContainer));
